import * as Yup from 'yup';

export const SelfDeliverySignUpSchema = Yup.object().shape({
  plan: Yup.string().required('Package selection is mandatory'),
  isAgreed: Yup.boolean().oneOf(
    [true],
    'You must approve the agreement before proceeding'
  ),
  signature: Yup.string().required('Your signature is required to continue'),
  promoCode: Yup.string()
    .matches(
      /^([a-zA-Z0-9_\-\u0600-\u06FF\u0660-\u0669\u06F0-\u06F9]+)$/,
      'Promo code can contain only numbers and letters as well as -, _ symbols'
    )
    .max(20, 'Your promo code is too long, max length is 20 characters!')
    .nullable()
});

export default SelfDeliverySignUpSchema;
